import React from 'react'
import { connect } from 'react-redux'

import Toolbar from '../../views/listview/Toolbar'
import Text from '../../views/typo/Text'

class PromotionListToolbar extends React.Component {
  promotionCount = () =>
    this.props.promotions ? this.props.promotions.length : undefined

  render() {
    const count = this.promotionCount()
    return (
      <Toolbar onAdd={this.props.onAddPromotion}>
        <Text className="subtitle">
          <strong>{count ? count : 'No'}</strong> Items
        </Text>
      </Toolbar>
    )
  }
}

export default connect(
  ({ portal }) => ({
    portalId: portal._id,
    promotions: portal.promotions,
  }),
  {
    // addLink,
  },
)(PromotionListToolbar)



// WEBPACK FOOTER //
// ./src/components/templates/promotion-list/PromotionListToolbar.js